'use client';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';
import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { MdOutlineSyncAlt } from 'react-icons/md';

type CategorySortProps = {
  className?: string;
};

export function CategorySort(props: CategorySortProps) {
  const { className } = props;
  const { t } = useTranslations();

  const { selectedValue, onSortChange, VALUES } = useCategorySort();

  return (
    <div
      className={cn(
        'flex w-full items-center justify-center gap-4 md:w-fit',
        'ea-category-sort',
        className,
      )}
    >
      <div className={cn('w-full sm:w-fit', 'ea-category-sort__select-wrapper')}>
        <Select value={selectedValue} onValueChange={e => onSortChange(e)}>
          <SelectTrigger
            aria-label={t('text341')}
            // placeholder={`${t('text341')}..`}
            innerTriggerClassName="px-3 gap-2 items-center justify-center"
            className={cn(
              'w-full gap-6 rounded-[4px] border border-border bg-transparent md:w-fit',
              'ea-category-sort__select-trigger',
            )}
            expandIcon={null}
          >
            <MdOutlineSyncAlt size={20} className="-rotate-90 text-[#9CA3AF]" />
            <SelectValue
              placeholder={`${t('text341')}..`}
              className={cn('', 'ea-category-sort__select-value')}
            />
          </SelectTrigger>
          <SelectContent
            sideOffset={2}
            className={cn(
              'rounded-[4px] border border-border shadow-none',
              'ea-category-sort__select-content',
            )}
          >
            {VALUES?.map(o => (
              <SelectItem
                key={o.value}
                value={String(o.value)}
                className={cn('rounded-[4px]', 'ea-category-sort__select-item')}
              >
                {t(o.label)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default CategorySort;
